module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('keep-alive', [_c('div', {
    staticClass: "ksm-flex",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('ModusIndex', {
    attrs: {
      "viewKey": 'werbe'
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e556aa2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MerzWerbe.vue
// module id = 1954
// module chunks = 1